"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ok = exports.Bad = exports.BadFactory = exports.ResultWrapper = void 0;
class ResultWrapper {
    constructor(from) {
        var _a, _b;
        this.success = false;
        this.hasValue = false;
        if (from != undefined) {
            this.success = (_a = from.success) !== null && _a !== void 0 ? _a : false;
            this.hasValue = (_b = from.hasValue) !== null && _b !== void 0 ? _b : from.value !== undefined;
            this.value = from.value;
            this.reason = from.reason;
        }
    }
}
exports.ResultWrapper = ResultWrapper;
function ok(value) {
    if (value !== undefined)
        return new ResultWrapper({ success: true, hasValue: true, value });
    else
        return new ResultWrapper({ success: true });
}
function bad(reason, value) {
    if (value !== undefined)
        return new ResultWrapper({ success: false, reason, value, hasValue: true });
    else
        return new ResultWrapper({ success: false, reason });
}
function BadFactory(reason) {
    function factory(value) {
        return bad(reason, value);
    }
    return factory;
}
exports.BadFactory = BadFactory;
/**
 * Common shortcuts for bad results.
 */
(function (bad) {
    /**
     * The current actor does not have sufficient rights to perform this operation.
     */
    bad.forbidden = BadFactory("FORBIDDEN");
    /**
     * The current actor is not authenticated, or its authentication cannot be verified.
     */
    bad.notAuthorized = BadFactory("NOT_AUTHORIZED");
    /**
     * The requested entity was not found
     */
    bad.notFound = BadFactory("NOT_FOUND");
    /**
     * Validation of the input parameters has failed.
     */
    bad.validationFailed = BadFactory("VALIDATION_FAILED");
})(bad || (bad = {}));
/**
 * A "Bad" result represents an operation that has failed, whose origin is known or which was predictable.
 * The result contains a reason describing why the operation has failed.
 * Note: any exceptional errors that cannot be compensated should not be represented as a result, but thrown as an exception (e.g.: a database transaction has failed, a request failed due to a network error, etc).
 */
exports.Bad = bad;
/**
 * An "Ok" result represents an operation that has been successfully completed.
 * The result may include a value.
 */
exports.Ok = ok;
//# sourceMappingURL=Result.js.map